module.exports = __webpack_public_path__ + "static/media/icon-weight.28bdea63.svg";